/**
 * Utility functions for UI interactions
 */

/**
 * Updates the styling of radio button groups to manually apply active states.
 * This ensures broad compatibility even without relying on CSS :has() selector.
 * 
 * @param {string} containerSelector The CSS selector for the radio buttons container (e.g. '.radio-btn-group label')
 */
export function updateRadioBtnStyles(containerSelector = '.radio-btn-group label') {
    document.querySelectorAll(containerSelector).forEach(lbl => {
        const input = lbl.querySelector('input');
        if (input && input.checked) {
            lbl.style.backgroundColor = 'var(--input-bg-transparent)';
            lbl.style.boxShadow = 'inset 0 0 5px rgba(0,0,0,0.2)';
        } else {
            lbl.style.backgroundColor = '';
            lbl.style.boxShadow = '';
        }
    });
}
